import { render, staticRenderFns } from "./StaffVehicles.vue?vue&type=template&id=3c595e44"
import script from "./StaffVehicles.vue?vue&type=script&lang=js"
export * from "./StaffVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports